import * as actionTypes from "../actions/actionTypes";

const initialState = {
  questions: [],
  moduleName: "",
  error: "",
  loading: false,
  startedTime: null,
};

const fetchQuestionsInProgress = (state, action) => {
  return {
    ...state,
    loading: true,
    error: "",
    moduleName: "",
    questions: [],
    startedTime: null,
  };
};

const fetchQuestionsSuccess = (state, action) => {
  return {
    ...state,
    questions: action.payload.questions,
    loading: false,
    error: "",
    moduleName: action.payload.moduleName,
    startedTime: Date.now(),
  };
};

const fetchQuestionsFailed = (state, action) => {
  return { ...state, loading: false, error: action.payload.error };
};

const questionsClearError = (state, action) => {
  return { ...state, error: "" };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_QUESTIONS_INPROGRESS:
      return fetchQuestionsInProgress(state, action);
    case actionTypes.FETCH_QUESTIONS_SUCCESS:
      return fetchQuestionsSuccess(state, action);
    case actionTypes.FETCH_QUESTIONS_FAILED:
      return fetchQuestionsFailed(state, action);
    case actionTypes.QUESTIONS_CLEAR_ERROR:
      return questionsClearError(state, action);
    default:
      return state;
  }
};

export default reducer;
